import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BobineLogo from '../components/BobineLogo';
import MobileNav from '../components/MobileNav';

const API = `${(process.env.REACT_APP_BACKEND_URL || 'https://bobine.live')}/api`;

const NumerisationPage = () => {
  const navigate = useNavigate();
  const isLoggedIn = !!localStorage.getItem('bobine_token');
  const [kits, setKits] = useState([]);
  const [selectedKit, setSelectedKit] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', phone: '', description: '' });
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    fetch(`${API}/numerisation/kits`).then(r => r.json()).then(d => setKits(d.kits || [])).catch(() => {});
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email) return;
    try {
      await fetch(`${API}/contact/numerisation`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...form, kit: selectedKit }),
      });
      setSubmitted(true);
    } catch { /* silent */ }
  };

  const serif = "'Georgia', 'Times New Roman', serif";

  const guarantees = [
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M7 11V7a5 5 0 0 1 10 0v4"/><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
        </svg>
      ),
      title: 'Gants de soie',
      desc: 'Chaque document est manipule avec des gants de soie pour une conservation parfaite.',
    },
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/>
        </svg>
      ),
      title: 'Nettoyage expert',
      desc: 'Nettoyage professionnel avant numerisation pour un rendu optimal.',
    },
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
        </svg>
      ),
      title: 'Suivi GPS securise',
      desc: 'Suivez vos archives en temps reel depuis votre espace Bobine.',
    },
    {
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
        </svg>
      ),
      title: 'Assurance tous risques',
      desc: 'Vos originaux sont couverts durant tout le processus de numerisation.',
    },
  ];

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#000' }}>
      <header style={{ borderBottom: '1px solid rgba(212,175,55,0.2)' }}>
        <div className="container mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
          <BobineLogo size={22} />
          <div className="hidden md:flex items-center gap-3">
            <button onClick={() => navigate(isLoggedIn ? '/dashboard' : '/compte')} data-testid="num-cta-header"
              style={{ fontFamily: serif, fontSize: 12, padding: '6px 14px', borderRadius: 6, cursor: 'pointer', backgroundColor: 'rgba(212,175,55,0.08)', color: '#000', border: 'none', fontWeight: 600 }}>
              {isLoggedIn ? 'Mon Coffre-fort' : 'Commencer'}
            </button>
          </div>
          <MobileNav items={[
            { label: 'Retour', action: () => navigate(-1) },
            { label: 'Accueil', action: () => navigate('/') },
            { label: 'Nos Offres', action: () => navigate('/offres') },
            { label: 'Services', action: () => navigate('/services') },
            { label: isLoggedIn ? 'Mon Coffre-fort' : 'Commencer', action: () => navigate(isLoggedIn ? '/dashboard' : '/compte') },
          ]} />
        </div>
      </header>

      <main className="container mx-auto px-4 sm:px-6 py-12 sm:py-16 max-w-5xl">
        {/* Bouton Retour identique à la page Offres */}
        <div style={{ marginBottom: 24 }}>
          <button onClick={() => navigate('/')} data-testid="back-btn"
            style={{ fontFamily: serif, fontSize: 14, padding: '10px 20px', borderRadius: 8, cursor: 'pointer', color: '#D4AF37', backgroundColor: 'rgba(212,175,55,0.08)', border: '1px solid rgba(212,175,55,0.3)', display: 'flex', alignItems: 'center', gap: 6, fontWeight: 500, transition: 'all 0.3s' }}
            onMouseEnter={e => { e.currentTarget.style.backgroundColor = 'rgba(212,175,55,0.15)'; }}
            onMouseLeave={e => { e.currentTarget.style.backgroundColor = 'rgba(212,175,55,0.08)'; }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="15 18 9 12 15 6"/></svg>
            Retour
          </button>
        </div>
        {/* Hero */}
        <div className="text-center" style={{ marginBottom: 56 }}>
          <h1 data-testid="numerisation-title" style={{ fontFamily: serif, fontSize: 36, color: '#D4AF37', marginBottom: 16, letterSpacing: 1 }}>
            Numerisation de vos archives
          </h1>
          <p style={{ fontFamily: serif, fontSize: 16, color: '#FAF3E0', lineHeight: 1.7, maxWidth: 560, margin: '0 auto' }}>
            Confiez-nous vos albums, tirages papier et negatifs. Nous numerisons chaque souvenir avec un soin de conservateur.
          </p>
        </div>

        {/* Kits */}
        <div className="grid sm:grid-cols-3 gap-6 mb-16" data-testid="kits-grid">
          {kits.map(kit => (
            <div
              key={kit.kit_id}
              data-testid={`kit-${kit.kit_id}`}
              onClick={() => { setSelectedKit(kit.kit_id); setShowForm(true); }}
              style={{
                position: 'relative', borderRadius: 14, padding: '28px 22px', cursor: 'pointer',
                border: selectedKit === kit.kit_id ? '2px solid #D4AF37' : kit.kit_id === 'coffret' ? '1px solid rgba(212,175,55,0.4)' : '1px solid rgba(212,175,55,0.15)',
                backgroundColor: selectedKit === kit.kit_id ? 'rgba(212,175,55,0.06)' : 'transparent',
                transition: 'all 0.3s',
              }}
            >
              {kit.kit_id === 'coffret' && (
                <div style={{
                  position: 'absolute', top: -10, left: '50%', transform: 'translateX(-50%)',
                  fontFamily: serif, fontSize: 10, fontWeight: 600, letterSpacing: 1.5,
                  color: '#000', background: 'linear-gradient(145deg, #D4AF37, #B8860B)', padding: '3px 12px', borderRadius: 10,
                  textTransform: 'uppercase',
                }}>
                  Recommande
                </div>
              )}
              <h3 style={{ fontFamily: serif, fontSize: 22, color: '#D4AF37', textAlign: 'center', marginBottom: 6 }}>
                {kit.name}
              </h3>
              <p style={{ fontFamily: serif, fontSize: 12, color: '#FAF3E0', textAlign: 'center', marginBottom: 16 }}>
                {kit.description}
              </p>
              <p style={{ fontFamily: serif, fontSize: 36, color: '#D4AF37', textAlign: 'center', fontWeight: 500, marginBottom: 20 }}>
                {kit.price}<span style={{ fontSize: 16, color: '#D4AF37' }}>€</span>
              </p>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {(kit.includes || []).map((item, i) => (
                  <li key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, marginBottom: 6 }}>
                    <span style={{ color: '#D4AF37', fontSize: 11, marginTop: 2 }}>&#10003;</span>
                    <span style={{ fontFamily: serif, fontSize: 12, color: '#FAF3E0', lineHeight: 1.4 }}>{item}</span>
                  </li>
                ))}
              </ul>
              <button
                data-testid={`select-kit-${kit.kit_id}`}
                style={{
                  marginTop: 16, width: '100%', padding: '12px',
                  fontFamily: serif, fontSize: 13, fontWeight: 600,
                  backgroundColor: selectedKit === kit.kit_id ? '#D4AF37' : 'transparent',
                  color: selectedKit === kit.kit_id ? '#000' : '#D4AF37',
                  border: `1px solid ${selectedKit === kit.kit_id ? '#D4AF37' : 'rgba(212,175,55,0.4)'}`,
                  borderRadius: 8, cursor: 'pointer', transition: 'all 0.2s',
                }}
              >
                {selectedKit === kit.kit_id ? 'Selectionne' : 'Choisir ce kit'}
              </button>
            </div>
          ))}
        </div>

        {/* Note au-delà de 1500 */}
        <p data-testid="beyond-1500-note" style={{
          fontFamily: "'Georgia', 'Times New Roman', serif", fontSize: 12,
          color: '#D4AF37', textAlign: 'center', fontStyle: 'italic',
          marginTop: -8, marginBottom: 24, lineHeight: 1.6,
        }}>
          Au-delà de 1500 pièces, contactez-nous pour une étude personnalisée de votre patrimoine familial.
        </p>

        {/* Guarantees */}
        <div style={{ marginBottom: 56 }}>
          <h2 style={{ fontFamily: serif, fontSize: 22, color: '#D4AF37', textAlign: 'center', marginBottom: 32 }}>
            Nos engagements de conservation
          </h2>
          <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-6">
            {guarantees.map((g, i) => (
              <div key={i} data-testid={`guarantee-${i}`} className="text-center" style={{ padding: '20px 12px' }}>
                <div style={{ marginBottom: 12, display: 'flex', justifyContent: 'center' }}>{g.icon}</div>
                <h4 style={{ fontFamily: serif, fontSize: 14, color: '#D4AF37', marginBottom: 6, fontWeight: 600 }}>{g.title}</h4>
                <p style={{ fontFamily: serif, fontSize: 12, color: '#FAF3E0', lineHeight: 1.5 }}>{g.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Order Form */}
        {showForm && !submitted && (
          <div data-testid="numerisation-form" style={{
            maxWidth: 480, margin: '0 auto', padding: '32px 28px',
            border: '1px solid rgba(212,175,55,0.25)', borderRadius: 14,
            backgroundColor: 'rgba(212,175,55,0.02)',
          }}>
            <h3 style={{ fontFamily: serif, fontSize: 20, color: '#D4AF37', textAlign: 'center', marginBottom: 20 }}>
              Demander mon kit {kits.find(k => k.kit_id === selectedKit)?.name || ''}
            </h3>
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: 14 }}>
                <input
                  data-testid="num-input-name"
                  type="text" placeholder="Votre nom"
                  value={form.name} onChange={e => setForm({ ...form, name: e.target.value })}
                  required
                  style={{
                    width: '100%', padding: '12px 16px', borderRadius: 8,
                    fontFamily: serif, fontSize: 14,
                    backgroundColor: 'rgba(212,175,55,0.04)', border: '1px solid rgba(212,175,55,0.2)',
                    color: '#FAF3E0', outline: 'none',
                  }}
                />
              </div>
              <div style={{ marginBottom: 14 }}>
                <input
                  data-testid="num-input-email"
                  type="email" placeholder="Votre email"
                  value={form.email} onChange={e => setForm({ ...form, email: e.target.value })}
                  required
                  style={{
                    width: '100%', padding: '12px 16px', borderRadius: 8,
                    fontFamily: serif, fontSize: 14,
                    backgroundColor: 'rgba(212,175,55,0.04)', border: '1px solid rgba(212,175,55,0.2)',
                    color: '#FAF3E0', outline: 'none',
                  }}
                />
              </div>
              <div style={{ marginBottom: 14 }}>
                <input
                  data-testid="num-input-phone"
                  type="tel" placeholder="Telephone (optionnel)"
                  value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })}
                  style={{
                    width: '100%', padding: '12px 16px', borderRadius: 8,
                    fontFamily: serif, fontSize: 14,
                    backgroundColor: 'rgba(212,175,55,0.04)', border: '1px solid rgba(212,175,55,0.2)',
                    color: '#FAF3E0', outline: 'none',
                  }}
                />
              </div>
              <div style={{ marginBottom: 20 }}>
                <textarea
                  data-testid="num-input-description"
                  placeholder="Decrivez vos archives (type, quantite estimee, etat...)"
                  value={form.description} onChange={e => setForm({ ...form, description: e.target.value })}
                  rows={3}
                  required
                  style={{
                    width: '100%', padding: '12px 16px', borderRadius: 8,
                    fontFamily: serif, fontSize: 14,
                    backgroundColor: 'rgba(212,175,55,0.04)', border: '1px solid rgba(212,175,55,0.2)',
                    color: '#FAF3E0', outline: 'none', resize: 'vertical',
                  }}
                />
              </div>
              <button
                type="submit"
                data-testid="num-submit"
                style={{
                  width: '100%', padding: '14px',
                  fontFamily: serif, fontSize: 16, fontWeight: 600,
                  background: 'linear-gradient(145deg, #D4AF37, #B8860B)', color: '#000', border: 'none',
                  borderRadius: 10, cursor: 'pointer',
                  boxShadow: '0 4px 20px rgba(212,175,55,0.3)',
                  transition: 'all 0.3s',
                }}
              >
                Envoyer ma demande
              </button>
            </form>
          </div>
        )}

        {/* Success */}
        {submitted && (
          <div data-testid="numerisation-success" className="text-center" style={{
            maxWidth: 440, margin: '0 auto', padding: '40px 28px',
            border: '1px solid rgba(212,175,55,0.25)', borderRadius: 14,
          }}>
            <div style={{
              width: 56, height: 56, borderRadius: '50%', margin: '0 auto 20px',
              backgroundColor: 'rgba(212,175,55,0.1)', border: '2px solid #D4AF37',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="2"><polyline points="20 6 9 17 4 12"/></svg>
            </div>
            <h3 style={{ fontFamily: serif, fontSize: 22, color: '#D4AF37', marginBottom: 8 }}>
              Demande enregistree
            </h3>
            <p style={{ fontFamily: serif, fontSize: 14, color: '#FAF3E0', lineHeight: 1.7, marginBottom: 24 }}>
              Notre equipe vous contactera sous 24h pour organiser l'envoi de votre kit.
            </p>
            <button
              onClick={() => navigate(isLoggedIn ? '/dashboard' : '/')}
              data-testid="num-back-home"
              style={{ fontFamily: serif, fontSize: 14, padding: '12px 28px', borderRadius: 8, cursor: 'pointer', background: 'linear-gradient(145deg, #D4AF37, #B8860B)', color: '#000', border: 'none' }}
            >
              {isLoggedIn ? 'Retour au Coffre-fort' : 'Retour a l\'accueil'}
            </button>
          </div>
        )}
      </main>
    </div>
  );
};

export default NumerisationPage;
